import React from "react";

function PolygonEdgeHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Unlock Scalable Blockchain Solutions with Polygon zkEVM
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology leverages Polygon zkEVM to deliver scalable,
                    secure, and high-performance blockchain solutions tailored
                    for modern enterprises.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PolygonEdgeHero;
